import { render, staticRenderFns } from "./AppLoginModal.vue?vue&type=template&id=2a3b22ba&scoped=true&lang=pug&"
import script from "./AppLoginModal.vue?vue&type=script&lang=js&"
export * from "./AppLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./AppLoginModal.vue?vue&type=style&index=0&id=2a3b22ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3b22ba",
  null
  
)

export default component.exports